/* eslint-disable react/style-prop-object */
import React from 'react'
import styles from '../../css/index/Card.module.css'
import PropTypes from 'prop-types'

export default function Card ({ logo, title, text }) {
  return (
        <div className={styles.bodyCard}>
            <img src={logo} alt="logo" />
            <h4>{title}</h4>
            <p>{text}</p>
        </div>
  )
}

Card.propTypes = {
  title: PropTypes.string,
  logo: PropTypes.string,
  text: PropTypes.string
}
